<template>
  <div>
    <!-- <div class="login-page"></div> -->
    <iframe
      :src="sanitizedUrl"
      width="100%"
      height="500px"
      frameborder="0"
      scrolling="no"
    ></iframe>
  </div>
</template>

<script>
import { UserService } from "../../services/UserService.js";
import Palla from "palla-web-sdk";
export default {
  name: "redirect",
  data: function () {
    return {
      userService: new UserService(),
      webViewUrl: "", // Set the URL you want to load
      url: "https://www.google.com",
    };
  },
  methods: {
    cleanPhoneNumber(input) {
      return input.replace(/[\u200E\u200F\u202A-\u202E]/g, ""); // elimina caracteres de control LTR/RTL
    },
    async getUrlPalla() {
      try {
        let phone = this.cleanPhoneNumber(this.$route.params.receiver_id);
        const res = await this.userService.getPalla(phone);
        this.webViewUrl = res.data.data;
        window.open(this.webViewUrl, "_blank");

        //this.palla(this.webViewUrl);
        console.log("url paga", this.webViewUrl);
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
      }
    },

    palla(url) {
      try {
        const config = {
          copy: {
            paymentHeader: "Add Your Copy Here",
            paymentInfoText: "Add Your Copy Here",
          },
          styles: {
            paymentHeaderColor: "#FF5733",
          },
        };

        // Accessing the webViewUrl from Vue instance properties
        const iframe = document.createElement("iframe");
        iframe.setAttribute("src", url);
        var sendMessage = function sendMessage(msg) {
          return iframe && iframe.contentWindow
            ? iframe.contentWindow.postMessage(msg, "*")
            : null;
        };
        var messageHandler = function messageHandler(message) {
          if (message && message.origin === host) {
            if (message.data && message.data.id === "awaiting-config") {
              sendMessage({ id: "config", payload: config });
            } else if (
              message.data &&
              (message.data.id === "add-payment-success" ||
                message.data.id === "add-payment-error" ||
                message.data.id === "credential-error")
            ) {
              // Call cleanup
              cleanUp();
            }
          }
        };

        window.addEventListener("message", messageHandler);
        document.querySelector("body").appendChild(iframe);

        const cleanUp = () => {
          window.removeEventListener("message", messageHandler);
          iframe.remove();
        };

        console.log("url paga", this.webViewUrl);
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
      }
    },
  },

  mounted: function () {
    if (this.$route.params.receiver_id != 0) {
      debugger;
      this.getUrlPalla();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);
img {
  height: 130px;
  width: auto;
  margin-bottom: 40px;
  margin-top: 20px;
}
#bg {
  background-image: url("../../assets/bg_2.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
}
.login-page {
  width: 360px;
  padding: 8% 0 0;
  margin: 0 auto;
}
.form {
  border-radius: 10px;
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: inherit;
  margin: 0 auto 40px;
  padding: 45px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #4caf50;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.form button:hover,
.form button:active,
.form button:focus {
  background: #43a047;
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color: #4caf50;
  text-decoration: none;
}
.form .register-form {
  display: none;
}
.loader {
  display: flex;
  height: 20px;
  justify-content: center;
  align-items: center;
}
.spinner {
  height: 20px;
  width: 20px;
  border: 6px solid rgba(0, 0, 0, 0.2);
  border-top-color: rgba(0, 0, 0, 0.8);
  border-radius: 100%;
  animation: rotation 0.6s infinite linear 0.25s;

  /* the opacity is used to lazyload the spinner, see animation delay */
  /* this avoid the spinner to be displayed when visible for a very short period of time */
  opacity: 0;
}
@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}
.err-message {
  color: red;
  font-weight: 700;
}
.app-title {
  font-size: 2rem;
  color: dodgerblue;
  font-weight: bold;
}
@media screen and (max-width: 500px) {
  .login-page {
    width: 300px;
    padding-top: 100px;
  }
  .form {
    padding: 29px;
  }
}
</style>
